import React, { useState } from 'react';

import { TwTable } from '../../../components/TailwindTable';
import { Button as CmpButton } from '../../../components/Button';

const statusLabels = {
  NotFound: 'Not found',
  NotPromotedToEnvironment: 'Not promoted to this environment',
  TagMismatch: 'Wrong type',
  Invalid: 'Invalid',
};

const kindLabels = {
  Workflow: 'Workflow',
  Smartform: 'SmartForm',
  DistributionList: 'Distribution list',
  TextLibraryFolder: 'Text library folder',
};

export const PAGE_SIZE = 50;

const Header = ({ children }) => <TwTable.Header additionalClass="pl-4 uppercase">{children}</TwTable.Header>;
const Col = ({ children, additionalClass = '' }) => <TwTable.BodyCol additionalClass={`pl-4 py-2 ${additionalClass}`}>{children}</TwTable.BodyCol>;

// An import can hold thousands of connections; rendering them all makes the confirm button a long scroll away.
export function Limited({ items, children }) {
  const [shown, setShown] = useState(PAGE_SIZE);
  const remaining = items.length - shown;
  return (
    <>
      {children(items.slice(0, shown))}
      {remaining > 0 && (
        <div className="m-3 flex flex-wrap items-center gap-3 text-sm">
          <span className="text-gray-600 dark:text-gray-400">Showing {shown} of {items.length}</span>
          <CmpButton variant={CmpButton.variants.secondary} onClick={() => setShown(s => s + PAGE_SIZE)}>
            Show {Math.min(PAGE_SIZE, remaining)} more
          </CmpButton>
        </div>
      )}
    </>
  );
}

export function ReferenceTable({ plan }) {
  return (
    <Limited items={plan.referenceWarnings}>
      {rows => (
        <TwTable>
          <TwTable.Head>
            <Header>Type</Header>
            <Header>Id</Header>
            <Header>Problem</Header>
            <Header>Used by</Header>
          </TwTable.Head>
          <TwTable.Body>
            {rows.map(w => (
              <TwTable.BodyRow key={`${w.kind}|${w.referenceId}`} useHover={false}>
                <Col>{kindLabels[w.kind] || w.kind}</Col>
                <Col additionalClass="break-all">{w.referenceId}</Col>
                <Col>{statusLabels[w.status] || w.status}</Col>
                <Col>
                  {w.documents.length === 1
                    ? w.documents[0]
                    : <span title={w.documents.join('\n')}>{w.documents.length} documents</span>}
                </Col>
              </TwTable.BodyRow>
            ))}
          </TwTable.Body>
        </TwTable>
      )}
    </Limited>
  );
}
